<template>
  <div style="overflow:auto">
    <div class="design-thumbnail" title="查看详情" @click="viewDesignDetail()" :class="{'left': (dataList && dataList.length > 10) }">
      <div class="design-thumbnail-column" v-for="colItem, index in dataList" :key="index">
        <div
          class="design-thumbnail-row"
          :style="`backgroundColor:${colItem.tradeStackColor}`"
          v-for="rowItem,index in rowList"
          :key="index"
        ></div>
      </div>
    </div>
    <el-dialog :visible="showDesignCard" :show-close="false" append-to-body>
      <div class="design-card">
        <el-card>
          <div class="design-card-title" v-if="dataList">
            <span>规格</span>
            <span>{{row}} * {{dataList.length}}</span>
          </div>
          <div
            class="design-card-content"
            style="max-width:1200px;max-height:500px;overflow:scroll"
            :class="{'left': (dataList && dataList.length > 10) }"
          >
            <div class="design-card-col" v-for="colItem,index in dataList" :key="index">
              <div style="margin:30px 0;overflow:hidden">{{colItem.abiBrandName}}</div>
              <div
                class="design-card-row"
                v-for="rowItem,index in rowList"
                :key="index"
                :style="`backgroundColor:${colItem.tradeStackColor}`"
              ><div>{{colItem.abiBrandName}}</div></div>
            </div>
          </div>
          <div style="display:flex; justify-content: center; margin:20px 0">
            <el-button type="primary" @click="viewDesignDetail">关闭</el-button>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    row: {
      type: String,
      default: ''
    }
  },
  computed: {
    rowList () {
      let list = []
      for (let i = 0; i < this.row; i++) {
        list.push(1)
      }
      return list
    }
  },
  data () {
    return {
      showDesignCard: false
    }
  },
  methods: {
    // 查看堆箱设计图
    viewDesignDetail () {
      this.showDesignCard = Boolean(1 - this.showDesignCard)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  display: none !important;
}
::v-deep .el-dialog__body {
  padding: 0;
}

.design-thumbnail {
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex: 1;
  .design-thumbnail-column {
    .design-thumbnail-row {
      width: 25px;
      height: 25px;
      border: 1px solid #c0c4cc;
      border-radius: 3px;
    }
  }
}
.design-card {
  position: absolute;
  // height: calc(100% + 120px);
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  background-color: pink;
  .design-card-title {
    display: flex;
    padding: 5px 0 20px;
    border-bottom: 1px solid#ebeef5;
    span {
      width: 50%;
      font-size: 18px;
      text-align: center;
      font-weight: 700;
    }
  }
  .design-card-content {
    display: flex;
    justify-content: center;
    .design-card-col {
      text-align: center;
      .design-card-row {
        width: 100px;
        height: 80px;
        color: #fff;
        margin: 10px 10px;
        border-radius: 12px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.left {
  justify-content: flex-start;
}
</style>
